import * as React from 'react';
import {
  gtmEventDispatcher,
  AppStaticStateContext,
  ABTestingContext,
  PageContext,
  waitForGtmEvent,
} from '@packages/shared';
import { TRACKING_ID_PATH } from '@packages/common';

export const SessionStart: React.FC = () => {
  const { clientID, environment, locale, originalLocation } = React.useContext(AppStaticStateContext);
  const { title: abTestTitle, variant: abTestVariant, trafficSlotNumber } = React.useContext(ABTestingContext);
  const { pageType } = React.useContext(PageContext);

  React.useEffect(() => {
    fetch(TRACKING_ID_PATH).catch((error) => console.error(error));

    // Usercentrics sends an event called 'consent_status'. It is important that
    // the session starts after this event.
    // 'consent_status' is sent immediately for new users with the param 'type'
    // set to implicit. When the user makes a selection this event is sent again
    // with 'type' set to 'explicit'
    // For returning users that made a selection before the 'explicit' event is
    // sent directly and 'implicit' is omitted
    waitForGtmEvent('consent_status', 2).then(() => {
      gtmEventDispatcher.sessionStart({
        clientID,
        abTestTitle,
        abTestVariant,
        distributionFactor: trafficSlotNumber,
        environment,
        locale,
        originalLocation,
      });
      gtmEventDispatcher.initial();
    });
  }, [abTestTitle, clientID, trafficSlotNumber, environment, locale, originalLocation, pageType, abTestVariant]);

  return null;
};
